import { buildLivescoreQuery, type LivescoreQuery } from "./livescoreParams";
import type { LivescoreBoard } from "@/views/livescore/utils/livescore";

/**
 * Browser-side client for `GET /api/live/livescore`. The query is a selector
 * (date / sport / status), so the URL is short regardless of how many matches
 * are on, and every viewer of the same board shares one edge entry. Resolves
 * to null on failure (network, 5xx) so pollers can keep their last good board;
 * an empty board is a valid result (no matches for that filter) and is
 * returned as such.
 */
export async function fetchLivescoreBoard(query: LivescoreQuery): Promise<LivescoreBoard | null> {
    try {
        // no-store bypasses the browser's own HTTP cache only; Cloudflare still
        // serves its 15 s edge copy (see liveEventsClient.ts).
        const response = await fetch(`/api/live/livescore?${buildLivescoreQuery(query)}`, {
            headers: { Accept: "application/json" },
            cache: "no-store",
        });
        if (!response.ok) return null;
        const body = (await response.json()) as Partial<LivescoreBoard>;
        return { groups: Array.isArray(body.groups) ? body.groups : [], entities: body.entities ?? {} };
    } catch {
        return null;
    }
}
